// DNI (6 a 8 dígitos; 6 para documentos muy viejos) o CUIL/CUIT (11 dígitos), con o sin
// puntos/guiones. Misma regla que el backend (TramiteDeclaratoriaService.validarDniOCuil): se
// valida acá ANTES de mandar el alta, para avisar en el momento en vez de dejar que el back
// devuelva un error de base de datos por un valor demasiado largo o mal tipeado.

export function esDniOCuilValido(valor) {
    if (!valor || !valor.trim()) {
        return true; // opcional: el vacío se valida aparte (obligatorio o no) según el campo
    }
    const soloDigitos = valor.replace(/\D/g, '');
    const longitud = soloDigitos.length;
    return (longitud >= 6 && longitud <= 8) || longitud === 11;
}

export function mensajeDniOCuilInvalido(etiqueta) {
    return `${etiqueta} no es válido: debe ser un DNI (7 u 8 dígitos) o un CUIL/CUIT (11 dígitos).`;
}
